import * as React from 'react';
import Button from '@mui/material/Button';
import NextButton from '@mui/material-next/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import parse, { domToReact } from 'html-react-parser'
import { Alert, Chip, Divider } from '@mui/material';
import { Image } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import LoadingButton from '@mui/lab/LoadingButton';
import { useNavigate } from 'react-router';
import ApiFetch from '../ApiFetch';
import { LoginInfo } from '../../App';
import Constants from './Constants';
import { LinkContainer } from 'react-router-bootstrap';
import zIndex from '@mui/material/styles/zIndex';

export default function PlanConfirmDialog(props) {
  function getCoin(){
    return new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/coin/balance/").then((r)=>{
        return r.json()
    })
  }
  function createSubscription(planId){
    return new ApiFetch().post(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/payment/subscribe/"+planId,{}).then((r)=>{
        return r.json()
    })
  }
  function stopSubscription(planId){
    return new ApiFetch().delete(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/payment/subscribe/"+planId,{}).then((r)=>{
        return r.json()
    })
  }
  function createSubscriptionCoin(itemId){
    return new ApiFetch().post(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/coin/subscribe/"+itemId,{buyDiv:props.data.official ? "ITEM" : "PLAN"}).then((r)=>{
        return r.json()
    })
  }
  function stopSubscriptionCoin(subscriptionId){
    return new ApiFetch().delete(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/coin/subscribe/"+subscriptionId).then((r)=>{
        return r.json()
    })
  }
  const [open, setOpen] = React.useState(false);
  const [selected, setSelected] = React.useState("coin")
  const [proccessStart, setProccessStart] = React.useState(false)
  const [errorMessage, setErrorMessage] = React.useState("")
  const [coin, setCoin] = React.useState(0)
  // ログイン情報
  const {loginInfo,setLoginInfo} = React.useContext(LoginInfo)

  const navigate = useNavigate()

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false)
    setErrorMessage("")
    if(props.setShow){
      props.setShow(false)
    }
  };

  React.useEffect(() => {
    if(props.show){
      handleClickOpen()
    }
  },[props.show])

  React.useEffect(() => {
    if(proccessStart){
      //setTimeout(() => {navigate("/callback/start_support")},2000)
    }
  },[proccessStart])

  React.useEffect(() => {
    if(open){
      getCoin().then(r => {
        if(r.result){
          setCoin(r.data.balance)
        } else {
          setCoin(0)
        }
      })
    }
  },[open])

  function ageLimit(div){
    let list = ["全年齢","PG-12","R-15","R-18","R-18G"]
    return list[div-1]
  }
  // 本日
const today = new Date()

// 来月の1日
const nextMonthFirst = new Date(today.getFullYear(), today.getMonth() + 1, 1)

  return (
    <React.Fragment>
      <div className='text-center mt-1'>
        {props.data.status === undefined || props.data.status === '' ? <Button variant='contained' color='warning' onClick={handleClickOpen}>{props.data.item_id !== undefined ? "コインで購入する" : "支援する"}</Button> : <Button variant='outlined' color='warning' onClick={handleClickOpen}>{props.data.item_id !== undefined ? "登録済" : "支援中"}</Button>}
      </div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        style={{zIndex: zIndex.modal + 1000}} // モーダルのz-indexを上げる
      >
        <DialogTitle id="alert-dialog-title">
          {props.data.user_name || props.data.plan_user_name || ""}さんを支援
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <div style={{fontSize:"20px",width:"300px",overflow:"hidden"}}>{props.data.name || ""}</div>
            <Image src={(props.data.plan_id === undefined ? "/img/plan.webp" : ApiFetch.API_PROTOCOL+"//"+ApiFetch.IMG_HOST+"/plan/"+props.data.plan_id+".webp")} height={150} />
            <div>
                <div style={{height:"auto",width:"300px",overflow:"hidden"}}>
                  {parse((props.data.description || "").substring(0,200).replace(/\r|\n|\r\n/g,"<br/>"),{})}
                </div>
                {props.data.age_limit === undefined || props.data.age_limit === "" ? "" : <span style={{fontSize:"12px"}}>年齢区分・制限：{ageLimit(props.data.age_limit)}</span>}
                <Divider variant="middle" />
                <div className='text-center m-3'>
                    支払金額<br />
                    <span style={{fontWeight:"bold"}}>{Constants.CURRENCY_UNIT_LEFT} </span><span style={{fontSize:"26px",fontWeight:"bold"}}>{(props.data.amount || "").toLocaleString()}</span> <span style={{fontSize:"12px"}}>/月</span><br />
                </div>
                {props.data.status === undefined || props.data.status === '' ? (
                <div>
                  <b>支払方法</b>
                  <div className='m-2 p-2 d-none' style={{position:"relative",border:"1px solid lightblue",borderRadius:"30px",cursor:"pointer",backgroundColor:selected === "credit" ? "#e0ffff" : "inherit"}} onClick={() => {
                    setSelected("credit")
                  }}>
                    {selected === "credit" ? <Icon.CheckCircleFill style={{color:"green"}} /> : <Icon.Circle />}
                      <span style={{marginLeft:"10px"}}>クレジットカード</span>
                      {false ? <span style={{position:"absolute",right:"20px",fontSize:"14px"}}>{true ? "登録済" : "未登録"}</span> : ""}
                  </div>
                  <div className='m-2 p-2' style={{border:"1px solid lightblue",borderRadius:"30px",cursor:"pointer",backgroundColor:selected === "coin" ? "#e0ffff" : "inherit"}} onClick={() => {
                    setSelected("coin")
                  }}>
                    {selected === "coin" ? <Icon.CheckCircleFill style={{color:"green"}} /> : <Icon.Circle />}
                    <span style={{marginLeft:"10px"}}>コイン</span> <span style={{fontSize:"12px"}}>保有：{coin.toLocaleString()} 1コイン = 1円</span>
                  </div>
                  <div className='text-center d-none' style={{display:loginInfo.userId !== undefined ? "block" : "none"}}>
                    <Chip onClick={() => navigate("/manage/payment")} label="支払方法登録・変更" />
                  </div>
                  <div style={{fontSize:"12px"}} className='m-3'>
                    今回支払日：{today.toLocaleDateString()}<br />
                    次会支払日：{nextMonthFirst.toLocaleDateString()}<br />
                  </div>
                </div>) : ""}
            </div>
            <div className='text-center mt-1'>
              {(props.data.status === undefined || props.data.status === "") && props.data.amount > coin ? <Alert severity='info' className='m-3 text-left' style={{width:"270px"}}>
                コイン残高が不足しています。まず最初にコインをチャージしてください。<br />
                <LinkContainer to={"/coin"}><Button>チャージする</Button></LinkContainer>
              </Alert> : ""}
              {!proccessStart ? (props.data.status === undefined || props.data.status === "" ? <Button variant='contained' color='warning' onClick={() => {
                if(selected === "credit"){
                  createSubscription(props.data.plan_id).then(r => {
                    if(r.result){
                      navigate("/callback/start_support")
                    } else {
                      setErrorMessage(r.errors)
                    }
                    setProccessStart(false)
                  })
                } else if(selected === "coin"){
                  createSubscriptionCoin(props.data.official ? props.data.item_id : props.data.plan_id).then(r => {
                    if(r.result){
                      navigate("/callback/start_support?"+(props.data.official ? "" : "user_id="+props.data.user_id))
                    } else {
                      setErrorMessage(r.errors)
                    }
                    setProccessStart(false)
                  })
                }
                setProccessStart(true)
              }}>支援を開始する</Button> : <Button onClick={() => {
                if(selected === "credit"){
                  stopSubscription(props.data.plan_id).then(r => {
                    if(r.result){
                      navigate("/callback/end_support")
                    } else {
                      setErrorMessage(r.errors)
                    }
                    setProccessStart(false)
                  })
                } else if(selected === "coin"){
                  stopSubscriptionCoin(props.data.subscription_id).then(r => {
                    if(r.result){
                      navigate("/callback/end_support")
                    } else {
                      setErrorMessage(r.errors)
                    }
                    setProccessStart(false)
                  })
                }
                setProccessStart(true)
              }}>支援を停止する</Button>) :
              <LoadingButton loading variant="outlined" color='warning'>支援を開始する</LoadingButton>}
              {errorMessage.length > 0 ? <Alert severity='error' className='m-3 text-left' style={{width:"270px"}}>{errorMessage}</Alert> : ""}
            </div>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
}